import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth()"
      stroke-linecap="round"
      stroke-linejoin="round"
      [class]="class()"
    >
      <ng-container [ngSwitch]="name()">
        <!-- Hexagon -->
        <path *ngSwitchCase="'hexagon'" d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        
        <!-- Chat Bubble (Message Circle) -->
        <path *ngSwitchCase="'chat-bubble'" d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />

        <!-- Shield Alert (Risk) -->
        <path *ngSwitchCase="'shield-alert'" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <line *ngSwitchCase="'shield-alert'" x1="12" y1="8" x2="12" y2="12" />
        <line *ngSwitchCase="'shield-alert'" x1="12" y1="16" x2="12.01" y2="16" />

        <!-- Clock (Time) -->
        <circle *ngSwitchCase="'clock'" cx="12" cy="12" r="10" />
        <polyline *ngSwitchCase="'clock'" points="12 6 12 12 16 14" />

        <!-- Activity (Chart) -->
        <polyline *ngSwitchCase="'activity'" points="22 12 18 12 15 21 9 3 6 12 2 12" />

        <!-- Check Circle -->
        <path *ngSwitchCase="'check-circle'" d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline *ngSwitchCase="'check-circle'" points="22 4 12 14.01 9 11.01" />

        <!-- Bluetooth / Signal -->
        <path *ngSwitchCase="'bluetooth'" d="m7 7 10 10-5 5V2l5 5L7 17" />

        <!-- Battery -->
        <rect *ngSwitchCase="'battery'" x="1" y="6" width="18" height="12" rx="2" ry="2" />
        <line *ngSwitchCase="'battery'" x1="23" y1="13" x2="23" y2="11" />

        <!-- Server / Database -->
        <rect *ngSwitchCase="'server'" x="2" y="2" width="20" height="8" rx="2" ry="2" />
        <rect *ngSwitchCase="'server'" x="2" y="14" width="20" height="8" rx="2" ry="2" />
        <line *ngSwitchCase="'server'" x1="6" y1="6" x2="6.01" y2="6" />
        <line *ngSwitchCase="'server'" x1="6" y1="18" x2="6.01" y2="18" />

        <!-- Lock -->
        <rect *ngSwitchCase="'lock'" x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path *ngSwitchCase="'lock'" d="M7 11V7a5 5 0 0 1 10 0v4" />

        <!-- Factory / Industry -->
        <path *ngSwitchCase="'factory'" d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />

        <!-- Alert Triangle -->
        <path *ngSwitchCase="'alert-triangle'" d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
        <line *ngSwitchCase="'alert-triangle'" x1="12" y1="9" x2="12" y2="13" />
        <line *ngSwitchCase="'alert-triangle'" x1="12" y1="17" x2="12.01" y2="17" />
        
        <!-- Chevron Down -->
        <polyline *ngSwitchCase="'chevron-down'" points="6 9 12 15 18 9" />

        <!-- Chevron Up -->
        <polyline *ngSwitchCase="'chevron-up'" points="18 15 12 9 6 15" />

        <!-- Chevron Right -->
        <polyline *ngSwitchCase="'chevron-right'" points="9 18 15 12 9 6" />

        <!-- Chevron Left -->
        <polyline *ngSwitchCase="'chevron-left'" points="15 18 9 12 15 6" />

        <!-- Arrow Right -->
        <line *ngSwitchCase="'arrow-right'" x1="5" y1="12" x2="19" y2="12" />
        <polyline *ngSwitchCase="'arrow-right'" points="12 5 19 12 12 19" />

        <!-- Arrow Left -->
        <line *ngSwitchCase="'arrow-left'" x1="19" y1="12" x2="5" y2="12" />
        <polyline *ngSwitchCase="'arrow-left'" points="12 19 5 12 12 5" />

        <!-- Arrow Up -->
        <line *ngSwitchCase="'arrow-up'" x1="12" y1="19" x2="12" y2="5" />
        <polyline *ngSwitchCase="'arrow-up'" points="5 12 12 5 19 12" />

        <!-- Arrow Down -->
        <line *ngSwitchCase="'arrow-down'" x1="12" y1="5" x2="12" y2="19" />
        <polyline *ngSwitchCase="'arrow-down'" points="19 12 12 19 5 12" />

        <!-- Thermometer -->
        <path *ngSwitchCase="'thermometer'" d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" />
        
        <!-- File Text -->
        <path *ngSwitchCase="'file-text'" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline *ngSwitchCase="'file-text'" points="14 2 14 8 20 8" />
        <line *ngSwitchCase="'file-text'" x1="16" y1="13" x2="8" y2="13" />
        <line *ngSwitchCase="'file-text'" x1="16" y1="17" x2="8" y2="17" />
        <polyline *ngSwitchCase="'file-text'" points="10 9 9 9 8 9" />

         <!-- Menu -->
        <line *ngSwitchCase="'menu'" x1="3" y1="12" x2="21" y2="12" />
        <line *ngSwitchCase="'menu'" x1="3" y1="6" x2="21" y2="6" />
        <line *ngSwitchCase="'menu'" x1="3" y1="18" x2="21" y2="18" />

        <!-- X -->
        <line *ngSwitchCase="'x'" x1="18" y1="6" x2="6" y2="18" />
        <line *ngSwitchCase="'x'" x1="6" y1="6" x2="18" y2="18" />

        <!-- Mail -->
        <rect *ngSwitchCase="'mail'" width="20" height="16" x="2" y="4" rx="2" />
        <path *ngSwitchCase="'mail'" d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />

        <!-- Facebook -->
        <path *ngSwitchCase="'facebook'" d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />

        <!-- Instagram -->
        <rect *ngSwitchCase="'instagram'" width="20" height="20" x="2" y="2" rx="5" ry="5" />
        <path *ngSwitchCase="'instagram'" d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line *ngSwitchCase="'instagram'" x1="17.5" x2="17.51" y1="6.5" y2="6.5" />

        <!-- LinkedIn -->
        <path *ngSwitchCase="'linkedin'" d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
        <rect *ngSwitchCase="'linkedin'" width="4" height="12" x="2" y="9" />
        <circle *ngSwitchCase="'linkedin'" cx="4" cy="4" r="2" />

        <!-- WhatsApp -->
        <path *ngSwitchCase="'whatsapp'" fill="currentColor" stroke="none" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91a9.816 9.816 0 0 0-2.85-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z" />

        <!-- Default Circle -->
        <circle *ngSwitchDefault cx="12" cy="12" r="10" />
      </ng-container>
    </svg>
  `
})
export class IconComponent {
  name = input.required<string>();
  size = input<number>(24);
  class = input<string>('');
  strokeWidth = input<number>(2);
}